import { jsx as l, jsxs as i } from "react/jsx-runtime";
import "react";
var d = (t) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [
    /* @__PURE__ */ l("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ l("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1258 -380)",
      fill: "white"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#FF9811"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ l("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5ZM8.7373 10.9189C8.99092 11.2669 9.384 11.5064 9.83496 11.5537L9.51758 10.835L8.7373 10.9189ZM10.1641 11.5537C10.6152 11.5066 11.0079 11.2669 11.2617 10.9189L10.4814 10.835L10.1641 11.5537ZM8.57227 9.36621C8.48611 9.56 8.43751 9.77425 8.4375 10C8.4375 10.2254 8.48635 10.4392 8.57227 10.6328L9.03613 10L8.57227 9.36621ZM10.9639 10L11.4268 10.6328C11.5128 10.4391 11.5625 10.2256 11.5625 10C11.5625 9.7741 11.513 9.5601 11.4268 9.36621L10.9639 10ZM9.83496 8.44531C9.38426 8.49261 8.99096 8.73251 8.7373 9.08008L9.51758 9.16504L9.83496 8.44531ZM10.4814 9.16504L11.2617 9.08008C11.0079 8.73251 10.615 8.49233 10.1641 8.44531L10.4814 9.16504Z",
      fill: "#0052B4"
    })
  ]
});
export {
  d as default
};
